import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useT, LangToggle } from "../i18n/LanguageContext";

const LOGO = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/3m4xmkko_mother%20hippo%20PNG.png";

const copy = {
  en: {
    back: "SELECTOR",
    actNow: "ACT NOW",
    manifesto: "MANIFESTO · VOL. I",
    heroA: "BODILY",
    heroAccent: "AUTONOMY",
    heroB: "IS A",
    heroRed: "HUMAN",
    heroC: "RIGHT.",
    heroSub: "End Female Genital Mutilation. End it in our lifetime. End it before another girl is told her body belongs to anyone but her.",
    joinMovement: "JOIN THE MOVEMENT",
    readDemands: "READ THE 4 DEMANDS",
    bigNum: "200,000,000",
    bigNumLabel: "Women & girls alive today have been cut",
    bigNumSrc: "SOURCE: WHO · 2024",
    marquee: ["OUR BODIES", "OUR RIGHTS", "OUR FUTURE", "END FGM NOW", "GIRLS ARE NOT NEGOTIABLE", "SILENCE IS COMPLICITY"],
    stats: [
      { n: "230K+", l: "PEOPLE REACHED" },
      { n: "47", l: "VILLAGES" },
      { n: "12", l: "COUNTRIES" },
      { n: "100%", l: "SURVIVOR-LED" },
    ],
    manifestoKicker: "THE MANIFESTO",
    manifestoHeadA: "WE DO NOT",
    manifestoHeadB: "ASK. WE",
    manifestoHeadC: "INSIST.",
    mP1: { a: "Mother Hippo Foundation", b: " is not a charity. It is a coalition of survivors, mothers, midwives, doctors, lawyers, and girls who have decided the cutting ends here. With them. In this generation." },
    mP2: "We reject the framing that FGM is a \"cultural issue.\" It is a violation — of children, of health, of the most basic right a human being has to their own body. Culture is alive. Culture changes. We are the proof.",
    mP3: "We work loudly in public and patiently in private. We protect anonymity when we must, and we name names when we must. We do not flinch.",
    demandsHeadA: "FOUR",
    demandsHeadB: "DEMANDS.",
    demandsSub: "NON-NEGOTIABLE / PROGRESSIVELY MEASURED / PUBLICLY SCORED",
    demands: [
      { n: "01", t: "COMMUNITY MOBILISATION", d: "We fund grassroots activists in 47 villages — the people who know the names, the houses, the hours when girls are most at risk." },
      { n: "02", t: "SURVIVOR HEALTHCARE", d: "Free clinical care, trauma support, and reconstructive referrals. No forms. No shame. No gatekeeping." },
      { n: "03", t: "LEGISLATIVE PRESSURE", d: "We draft, lobby, and publicly grade every government we work with. FGM must be illegal, and the law must be enforced." },
      { n: "04", t: "EDUCATION AS REFUSAL", d: "A girl in a classroom is a girl saying NO. We keep her there — with scholarships, safehouses, and scholarships for her mother too." },
    ],
    voicesKicker: "VOICES FROM THE FRONT",
    voices: [
      { q: "I SURVIVED. NOW I RECRUIT.", a: "— AMINATA, 24", p: "BAMAKO" },
      { q: "WE BURIED THE BLADE IN 2023. IT IS NOT COMING BACK.", a: "— MAMA YAA", p: "ASHANTI" },
      { q: "MY DAUGHTER WILL NOT WHISPER.", a: "— ZAINAB", p: "KHARTOUM" },
    ],
    donateKicker: "ACT NOW",
    donateHeadA: "FUND",
    donateHeadB: "THE",
    donateHeadC: "FIGHT.",
    donateSub: "Every dollar is a girl's tomorrow bought back from yesterday. Monthly giving is how we keep the pressure on.",
    donateTiers: [
      { a: "$25", l: "FUND A CIRCLE / MONTH" },
      { a: "$75", l: "FUND A SCHOLARSHIP / MONTH" },
      { a: "$250", l: "FUND A SAFEHOUSE BED / MONTH" },
      { a: "OTHER", l: "CUSTOM AMOUNT" },
    ],
    contactKicker: "TRANSMISSIONS",
    contactHeadA: "GET IN",
    contactHeadB: "CONTACT.",
    contactSub: "Press. Partnerships. Survivor support. Whistleblowing. We answer.",
    contacts: [
      { h: "PRESS", v: "press@motherhippo.org" },
      { h: "PARTNERSHIPS", v: "allies@motherhippo.org" },
      { h: "SURVIVOR LINE", v: "+1 (240) 354-7951" },
      { h: "HQ", v: "NAIROBI · ACCRA · DC" },
    ],
    footerTagA: "END FGM ·",
    footerTagB: "IN OUR",
    footerTagC: "LIFETIME.",
    rights: "© 2026 MOTHER HIPPO FOUNDATION",
  },
  fr: {
    back: "SÉLECTEUR",
    actNow: "AGIR",
    manifesto: "MANIFESTE · VOL. I",
    heroA: "L'AUTONOMIE",
    heroAccent: "CORPORELLE",
    heroB: "EST UN",
    heroRed: "DROIT",
    heroC: "HUMAIN.",
    heroSub: "Mettre fin aux Mutilations Génitales Féminines. Y mettre fin de notre vivant. Avant qu'une autre fille ne s'entende dire que son corps appartient à quelqu'un d'autre qu'elle.",
    joinMovement: "REJOIGNEZ LE MOUVEMENT",
    readDemands: "LIRE LES 4 EXIGENCES",
    bigNum: "200,000,000",
    bigNumLabel: "Femmes & filles vivant aujourd'hui ont été excisées",
    bigNumSrc: "SOURCE : OMS · 2024",
    marquee: ["NOS CORPS", "NOS DROITS", "NOTRE AVENIR", "STOP MGF", "LES FILLES NE SE NÉGOCIENT PAS", "LE SILENCE EST COMPLICITÉ"],
    stats: [
      { n: "230K+", l: "PERSONNES TOUCHÉES" },
      { n: "47", l: "VILLAGES" },
      { n: "12", l: "PAYS" },
      { n: "100%", l: "DIRIGÉ PAR SURVIVANTES" },
    ],
    manifestoKicker: "LE MANIFESTE",
    manifestoHeadA: "NOUS NE",
    manifestoHeadB: "DEMANDONS PAS.",
    manifestoHeadC: "NOUS EXIGEONS.",
    mP1: { a: "La Mother Hippo Foundation", b: " n'est pas une œuvre de charité. C'est une coalition de survivantes, mères, sages-femmes, médecins, avocates et filles qui ont décidé que l'excision s'arrête ici. Avec elles. Dans cette génération." },
    mP2: "Nous rejetons l'idée que les MGF sont une « question culturelle ». C'est une violation — d'enfants, de santé, du droit le plus fondamental qu'un être humain ait sur son propre corps. La culture est vivante. La culture change. Nous en sommes la preuve.",
    mP3: "Nous travaillons haut en public et patiemment en privé. Nous protégeons l'anonymat quand il le faut, et nous nommons les noms quand il le faut. Nous ne flanchons pas.",
    demandsHeadA: "QUATRE",
    demandsHeadB: "EXIGENCES.",
    demandsSub: "NON-NÉGOCIABLES / MESURÉES / NOTÉES PUBLIQUEMENT",
    demands: [
      { n: "01", t: "MOBILISATION COMMUNAUTAIRE", d: "Nous finançons les militantes de terrain dans 47 villages — celles qui connaissent les noms, les maisons, les heures où les filles sont le plus en danger." },
      { n: "02", t: "SOINS AUX SURVIVANTES", d: "Soins cliniques gratuits, accompagnement trauma, orientations reconstructives. Sans formulaires. Sans honte. Sans filtres." },
      { n: "03", t: "PRESSION LÉGISLATIVE", d: "Nous rédigeons, faisons pression et notons publiquement chaque gouvernement. Les MGF doivent être illégales, et la loi doit être appliquée." },
      { n: "04", t: "L'ÉDUCATION COMME REFUS", d: "Une fille en classe est une fille qui dit NON. Nous la maintenons — avec des bourses, des maisons-refuges, et des bourses pour sa mère aussi." },
    ],
    voicesKicker: "VOIX DU FRONT",
    voices: [
      { q: "J'AI SURVÉCU. MAINTENANT JE RECRUTE.", a: "— AMINATA, 24", p: "BAMAKO" },
      { q: "NOUS AVONS ENTERRÉ LA LAME EN 2023. ELLE NE REVIENDRA PAS.", a: "— MAMA YAA", p: "ASHANTI" },
      { q: "MA FILLE NE CHUCHOTERA PAS.", a: "— ZAINAB", p: "KHARTOUM" },
    ],
    donateKicker: "AGIR",
    donateHeadA: "FINANCER",
    donateHeadB: "LE",
    donateHeadC: "COMBAT.",
    donateSub: "Chaque dollar est un lendemain de fille racheté à hier. Le don mensuel, c'est ce qui maintient la pression.",
    donateTiers: [
      { a: "25 $", l: "FINANCER UN CERCLE / MOIS" },
      { a: "75 $", l: "FINANCER UNE BOURSE / MOIS" },
      { a: "250 $", l: "FINANCER UN LIT REFUGE / MOIS" },
      { a: "AUTRE", l: "MONTANT LIBRE" },
    ],
    contactKicker: "TRANSMISSIONS",
    contactHeadA: "NOUS",
    contactHeadB: "CONTACTER.",
    contactSub: "Presse. Partenariats. Soutien aux survivantes. Lancement d'alerte. Nous répondons.",
    contacts: [
      { h: "PRESSE", v: "press@motherhippo.org" },
      { h: "PARTENARIATS", v: "allies@motherhippo.org" },
      { h: "LIGNE SURVIVANTES", v: "+1 (240) 354-7951" },
      { h: "SIÈGE", v: "NAIROBI · ACCRA · DC" },
    ],
    footerTagA: "STOP MGF ·",
    footerTagB: "DE NOTRE",
    footerTagC: "VIVANT.",
    rights: "© 2026 MOTHER HIPPO FOUNDATION",
  },
};

export default function PrototypeActivist() {
  const t = useT(copy);

  return (
    <div
      data-testid="prototype-activist"
      className="min-h-screen bg-black text-white font-plex selection:bg-[#E3282B] selection:text-white"
    >
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b-2 border-[#E3282B]">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 text-[10px] tracking-[0.4em] uppercase text-white hover:text-[#D4A93B] transition-colors" data-testid="back-to-selector">
            <ArrowLeft size={12} />
            {t.back}
          </Link>
          <img src={LOGO} alt="Mother Hippo Foundation" className="h-11 w-auto object-contain" />
          <div className="flex items-center gap-3">
            <LangToggle variant="activist" testId="activist-lang-toggle" />
            <a
              href="#donate"
              data-testid="header-donate"
              className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-[#E3282B] text-white text-[11px] tracking-[0.3em] uppercase hover:bg-[#D4A93B] hover:text-black transition-colors"
              style={{ boxShadow: "4px 4px 0 0 #16A34A" }}
            >
              {t.actNow} <ArrowRight size={12} />
            </a>
          </div>
        </div>
      </header>

      {/* Breaking ticker */}
      <div className="bg-[#E3282B] text-white border-y-2 border-[#D4A93B] overflow-hidden">
        <div className="mh-marquee-track py-2 mh-no-scrollbar">
          {[...t.marquee, ...t.marquee].map((item, i) => (
            <span key={i} className="font-anton text-sm tracking-[0.3em] px-8 inline-flex items-center gap-8">
              {item}
              <span className="inline-block h-2 w-2 bg-[#D4A93B] rounded-full" />
            </span>
          ))}
        </div>
      </div>

      {/* HERO */}
      <section className="relative border-b-2 border-[#D4A93B]">
        <div className="grid grid-cols-12">
          <div className="col-span-12 lg:col-span-7 p-8 md:p-14 border-r-2 border-[#D4A93B] relative">
            <div className="text-[10px] tracking-[0.5em] uppercase text-[#D4A93B] mh-rise font-bold">
              {t.manifesto}
            </div>
            <h1
              data-testid="activist-hero-title"
              className="mh-rise mh-delay-1 font-anton uppercase mt-8 text-[14vw] md:text-[11vw] lg:text-[9vw] leading-[0.85] tracking-tight"
            >
              {t.heroA}<br />
              <span className="text-[#16A34A]">{t.heroAccent}</span><br />
              {t.heroB} <span className="text-[#E3282B]">{t.heroRed}</span><br />
              {t.heroC}
            </h1>
            <p className="mh-rise mh-delay-2 mt-10 max-w-xl text-base md:text-lg text-white/90 leading-relaxed">
              {t.heroSub}
            </p>
            <div className="mh-rise mh-delay-3 mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#donate"
                data-testid="activist-donate-cta"
                className="inline-flex items-center gap-3 px-8 py-4 bg-[#E3282B] text-white font-anton uppercase tracking-[0.2em] text-sm hover:bg-[#D4A93B] hover:text-black transition-colors"
                style={{ boxShadow: "6px 6px 0 0 #16A34A" }}
              >
                {t.joinMovement} <ArrowRight size={16} />
              </a>
              <a
                href="#demands"
                className="inline-flex items-center gap-2 text-[11px] tracking-[0.35em] uppercase border-b-2 border-[#D4A93B] pb-1 hover:border-[#16A34A] hover:text-[#16A34A] transition-colors"
              >
                {t.readDemands}
              </a>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-5 relative min-h-[400px] lg:min-h-0">
            <img
              src="https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/1avalk56_Screenshot%202026-04-30%20at%201.12.32%E2%80%AFPM.png"
              alt=""
              className="absolute inset-0 h-full w-full object-cover contrast-125 saturate-150"
            />
            <div className="absolute inset-0 bg-[#E3282B] mix-blend-multiply opacity-85" />
            <div className="absolute bottom-0 left-0 right-0 p-8 bg-[#D4A93B] text-black border-t-2 border-black">
              <div className="font-anton text-4xl md:text-5xl leading-[0.9]">
                {t.bigNum}
              </div>
              <div className="text-[11px] tracking-[0.35em] uppercase mt-3 font-bold">
                {t.bigNumLabel}
              </div>
              <div className="text-[10px] tracking-[0.3em] uppercase mt-1 text-black/70">
                {t.bigNumSrc}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS BLOCKS */}
      <section className="border-b-2 border-[#D4A93B]">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {t.stats.map((s, i) => {
            const bgs = ["#E3282B", "#000", "#16A34A", "#D4A93B"];
            const fgs = ["#fff", "#fff", "#000", "#000"];
            return (
              <div
                key={i}
                className="p-8 md:p-12 transition-colors duration-100"
                style={{ background: bgs[i], color: fgs[i] }}
                data-testid={`activist-stat-${i}`}
              >
                <div className="font-anton text-5xl md:text-7xl leading-none">{s.n}</div>
                <div className="mt-4 text-[10px] tracking-[0.4em] uppercase opacity-90 font-bold">{s.l}</div>
              </div>
            );
          })}
        </div>
      </section>

      {/* MISSION / THE MANIFESTO */}
      <section id="mission" className="border-b-2 border-[#D4A93B] py-20 md:py-28">
        <div className="max-w-[1600px] mx-auto px-8 md:px-14 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-4">
            <div className="text-[10px] tracking-[0.5em] uppercase text-[#E3282B] font-bold">{t.manifestoKicker}</div>
            <h2 className="font-anton uppercase text-5xl md:text-6xl leading-[0.9] mt-6">
              {t.manifestoHeadA}<br />{t.manifestoHeadB}<br /><span className="text-[#16A34A]">{t.manifestoHeadC}</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:col-start-6 space-y-6 text-base md:text-lg leading-relaxed text-white/90">
            <p>
              <span className="font-anton uppercase text-[#D4A93B] text-xl">{t.mP1.a}</span>{t.mP1.b}
            </p>
            <p>{t.mP2}</p>
            <p>{t.mP3}</p>
          </div>
        </div>
      </section>

      {/* DEMANDS */}
      <section id="demands" className="border-b-2 border-[#D4A93B]">
        <div className="max-w-[1600px] mx-auto px-8 md:px-14 py-20 md:py-28">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
            <h2 className="font-anton uppercase text-5xl md:text-7xl leading-[0.9]">
              <span className="text-[#D4A93B]">{t.demandsHeadA}</span><br/>{t.demandsHeadB}
            </h2>
            <div className="text-[10px] tracking-[0.4em] uppercase text-white/70 max-w-xs font-bold">
              {t.demandsSub}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0.5 bg-[#D4A93B] border-2 border-[#D4A93B]">
            {t.demands.map((d, i) => {
              const hoverBg = ["#E3282B", "#16A34A", "#D4A93B", "#E3282B"][i];
              const hoverFg = ["#fff", "#fff", "#000", "#fff"][i];
              return (
                <div
                  key={i}
                  data-testid={`activist-demand-${d.n}`}
                  className="bg-black p-10 md:p-14 group cursor-pointer transition-colors duration-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = hoverBg;
                    e.currentTarget.style.color = hoverFg;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#000";
                    e.currentTarget.style.color = "#fff";
                  }}
                >
                  <div className="font-anton text-[#D4A93B] group-hover:text-current text-xl tracking-[0.2em]">
                    {d.n}
                  </div>
                  <h3 className="font-anton uppercase text-3xl md:text-4xl leading-[0.95] mt-4">
                    {d.t}
                  </h3>
                  <p className="mt-5 text-sm md:text-base opacity-90 leading-relaxed max-w-md">
                    {d.d}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* VOICES */}
      <section className="border-b-2 border-[#D4A93B] py-20 md:py-28 bg-[#16A34A]/10">
        <div className="max-w-[1600px] mx-auto px-8 md:px-14">
          <div className="text-[10px] tracking-[0.5em] uppercase text-[#16A34A] font-bold">{t.voicesKicker}</div>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-8">
            {t.voices.map((v, i) => {
              const borderColors = ["#E3282B", "#D4A93B", "#16A34A"];
              return (
                <div
                  key={i}
                  className="border-2 p-8 bg-black hover:bg-[#D4A93B] hover:text-black transition-colors duration-100"
                  style={{ borderColor: borderColors[i] }}
                  data-testid={`activist-voice-${i}`}
                >
                  <div className="font-anton uppercase text-3xl md:text-4xl leading-[0.95]">
                    "{v.q}"
                  </div>
                  <div
                    className="mt-10 text-[10px] tracking-[0.4em] uppercase font-bold"
                    style={{ color: borderColors[i] }}
                  >
                    {v.a}
                  </div>
                  <div className="text-[10px] tracking-[0.3em] uppercase opacity-70 mt-1">{v.p}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* DONATE */}
      <section id="donate" className="border-b-2 border-[#D4A93B]">
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-6 p-10 md:p-16 bg-[#E3282B] border-r-2 border-black">
            <div className="text-[10px] tracking-[0.5em] uppercase text-black font-bold">{t.donateKicker}</div>
            <h2 className="font-anton uppercase text-6xl md:text-8xl leading-[0.88] mt-6">
              {t.donateHeadA}<br/>{t.donateHeadB}<br/><span className="text-[#D4A93B]">{t.donateHeadC}</span>
            </h2>
            <p className="mt-8 max-w-md text-base text-white/95 leading-relaxed">
              {t.donateSub}
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 bg-[#16A34A] p-10 md:p-16 space-y-4">
            {t.donateTiers.map((d, i) => (
              <button
                key={i}
                data-testid={`activist-donate-${i}`}
                className="w-full flex items-center justify-between px-6 py-5 border-2 border-black bg-black text-white hover:bg-[#D4A93B] hover:text-black transition-colors duration-100 group"
              >
                <span className="font-anton uppercase text-3xl">{d.a}</span>
                <span className="text-[11px] tracking-[0.3em] uppercase font-bold">{d.l}</span>
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="border-b-2 border-[#D4A93B] py-20 md:py-28">
        <div className="max-w-[1600px] mx-auto px-8 md:px-14 grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="text-[10px] tracking-[0.5em] uppercase text-[#E3282B] font-bold">{t.contactKicker}</div>
            <h2 className="font-anton uppercase text-5xl md:text-7xl leading-[0.9] mt-6">
              {t.contactHeadA}<br/><span className="text-[#D4A93B]">{t.contactHeadB}</span>
            </h2>
            <p className="mt-6 max-w-md text-white/80">
              {t.contactSub}
            </p>
          </div>
          <div className="col-span-12 md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-0.5 bg-[#D4A93B] border-2 border-[#D4A93B]">
            {t.contacts.map((c, i) => {
              const accents = ["#E3282B", "#16A34A", "#D4A93B", "#fff"];
              return (
                <div key={i} className="bg-black p-8">
                  <div className="text-[10px] tracking-[0.4em] uppercase font-bold" style={{ color: accents[i] }}>{c.h}</div>
                  <div className="font-anton uppercase text-2xl mt-3 break-all">{c.v}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 bg-[#D4A93B] text-black">
        <div className="max-w-[1600px] mx-auto px-8 md:px-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <img src={LOGO} alt="" className="h-12 w-auto object-contain" />
          <div className="font-anton uppercase text-2xl tracking-[0.15em]">
            {t.footerTagA} <span className="text-[#16A34A]">{t.footerTagB}</span> {t.footerTagC}
          </div>
          <div className="text-[10px] tracking-[0.4em] uppercase font-bold">
            {t.rights}
          </div>
        </div>
      </footer>
    </div>
  );
}
